var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{staticClass:"d-flex justify-content-center"},[_c('v-spacer'),_c('v-row',{staticStyle:{"width":"70%"}},[_c('v-col',[_c('contact-us',{attrs:{"title":'Know Your Customer',"image-url":_vm.kycImage,"email":_vm.email,"phone":_vm.phone}})],1)],1),_c('v-spacer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }